import { styled } from '@/lib/utils'

export const HomeContainer = styled('div')('flex flex-col gap-4 pb-25')

export const EmptyContainer = styled('div')('grid gap-6')
export const GlassCardContainer = styled('div')(
  'grid xl:grid-cols-2 xl:grid-rows-2 gap-6'
)
export const GlassCard = styled('div')(
  'bg-white/20 rounded-lg shadow-[0_4px_30px_rgba(0,0,0,0.1)]',
  'backdrop-blur-sm border border-white/30'
)
